import React from 'react';
// import './Footer.css';

const Footer = () => (
  <footer>
    <p>&copy; {new Date().getFullYear()} Pursync. All rights reserved.</p>
  </footer>
);

export default Footer;
